import Env from "../base/env";
import gsap from "gsap";
import { renderAmount, formatDollarsToCents } from "../utils/ShopifyHelpers";
import Channels from "../base/channels";

let timeoutSample = false;

export default () => ({
  items: [],
  itemsSamples: [],
  itemsBundle: [],
  itemsMiniFragrances: [],
  miniFragrances: [],
  bundles: [],
  bundleBtnsDisabled: false,
  samples: [],
  itemsCount: 0,
  itemsMiniFragrancesCount: 0,
  samplesCount: 0,
  samplesMax: 2,
  samplesEnabled: false,
  miniFragranceId: 0,
  disableMiniFragranceForm: true,
  patternBuy: false,
  RAF: false,
  total: 0,
  async init() {
    this.getCart();
    this.getSamples();
    this.getMiniFragrances();
    this.getItemsBundle();
    this.watch();
    Channels.addListener("cart::render", () => {
      this.getCart(false, () => {
        if (this.patternBuy == "direct") {
          this.openCart();
        }
      });
    });
  },
  addToCart() {
    Channels.emit("addtocart::click");
  },
  addOneItem(item) {
    const data = {
      id: item.key,
      quantity: item.quantity + 1,
    };
    this.updateItem(data);
    this.getCart(true);
  },
  deleteOneItem(item) {
    const data = {
      id: item.key,
      quantity: item.quantity - 1,
    };
    this.updateItem(data);
    this.getCart(true);
  },
  watch() {
    this.RAF = requestAnimationFrame(() => {
      this.listenStock();
      this.watch();
    });
  },
  removeItemToBundle(item) {
    let itemRemoved = false;
    const reversedItems = this.bundles.reverse();
    let newItems = [];
    for (let el of reversedItems) {
      if (el.id == item.id && itemRemoved == false) {
        this.bundleCount--;
        itemRemoved = true;
        item.active = false;
      } else {
        newItems.push(el);
      }
    }
    this.bundles = newItems.reverse();

    this.checkBundle();
  },
  addItemToBundle(item) {
    this.bundleCount++;
    this.bundles.push(item);

    this.checkBundle();
  },
  checkBundle() {
    for (let ref of this.bundles) {
      ref.active = true;
    }
    if (this.bundleCount == this.bundleMax) {
      this.bundleBtnsDisabled = true;
      Channels.emit("bundle::ready");
    } else {
      this.bundleBtnsDisabled = false;
      Channels.emit("bundle::adding");
    }
    // Show Progress
    const $bundleProgress = document.querySelectorAll(".jsBundleProgress");
    const progress = this.bundleCount / this.bundleMax;
    gsap.to($bundleProgress, {
      scaleX: progress,
      duration: 0.5,
      ease: "cubic.inOut",
    });
  },
  captureSamples(data) {
    this.samples = [];
    for (let item of data.items) {
      if (
        item.properties._free_sample == "true" ||
        item.properties._free_sample == true
      ) {
        this.samplesCount += item.quantity;
        this.samples.push(item);
      }
    }

    if (this.itemsSamples.length) {
      for (let cleanSample of this.itemsSamples) {
        cleanSample.enabled = false;
        cleanSample.title_rendered = cleanSample.title;
      }
    }
    // console.log(this.samples);
    if (this.itemsSamples.length) {
      for (let itemSample of this.itemsSamples) {
        for (let cartSample of this.samples) {
          if (cartSample.id == itemSample.variants[0].id) {
            itemSample.enabled = true;
            itemSample.title_rendered =
              cartSample.title + "(" + cartSample.quantity + ")";
            itemSample.quantity = cartSample.quantity;
            itemSample.key_cart = cartSample.key;
            break;
          }
        }
      }
    }
    timeoutSample = setTimeout(() => {
      Env.$html.classList.remove("sample-updated");
    }, 1000);
  },
  closeMiniFragrancesGifts() {
    Channels.emit("fragrances-gifts::close");
  },
  closeCart() {
    Channels.emit("cart::close");

    clearInterval(this.validationInterval);
  },
  btnSubmitFragrancesText() {
    if (this.disableMiniFragranceForm == true) {
      return translations.fragrance_drawer_choice;
    } else {
      return translations.fragrance_drawer_submit;
    }
  },
  disableOtherFragrances(actived) {
    this.itemsMiniFragrancesCount = 0;
    if (actived == 0) {
      this.disableMiniFragranceForm = true;
      this.miniFragranceId = 0;
    }
    for (let item of this.itemsMiniFragrances) {
      if (item.id != actived) {
        item.enabled = false;
      } else {
        this.itemsMiniFragrancesCount++;
      }
    }
  },
  listenStock() {
    if (document.querySelector(".js-stock-check") != null) {
      const style = window.getComputedStyle(
        document.querySelector(".js-stock-check"),
        null,
      );
      let display = style.getPropertyValue("display");
      if (display == "flex") {
        Env.$html.classList.add("product-unavailable");
      } else {
        Env.$html.classList.remove("product-unavailable");
      }
    }
  },
  openMiniFragrancesGifts() {
    Channels.emit("fragrances-gifts::open");
  },
  openCart() {
    Channels.emit("cart::open");

    this.validationInterval = setInterval(() => {
      this.validateSampleCount();
    }, 300);
  },
  async freeShippingAvailable() {
    const baseAmount = formatDollarsToCents(this.base_amount);
    let total = 0;
    this.items.forEach((item) => {
      const getPrice = this.getProductPrice(item);
      total += getPrice * item.quantity;
    });
    let amount = baseAmount - total;
    if (amount < 0) {
      return this.text_success;
    } else {
      return this.text.replace("{{ amount }}", renderAmount(amount));
    }
  },
  getCart(state, fnComplete = null) {
    const delay = state ? 0.5 : 0;

    gsap.delayedCall(delay, () => {
      // console.log("cart update");
      fetch("/cart.js", {
        method: "get",
      })
        .then((response) => response.json())
        .then((data) => {
          // console.log(data);
          // Clear if sample on cart and total == 0
          this.refreshCartDisplay(data);
          // this.itemsCount = data.item_count;
          this.samplesCount = 0;
          // this.total = data.total_price;
          // this.items = data.items;
          //! Test Samples
          this.toggleSamplesBox(data);
          this.captureSamples(data);
          if (
            typeof fnComplete != "undefined" &&
            typeof fnComplete == "function"
          )
            fnComplete();

          if (data.item_count > 0 && data.total_price == 0) {
            this.resetCart();
          }
        })
        .catch((error) => {
          console.error("Error adding item to cart:", error);
        });
    });
  },
  validateSampleCount() {
    if (this.samplesCount > this.samplesMax) {
      console.log("Too many samples", this.samplesCount, "/", this.samplesMax);

      let datas = { updates: {} };
      let excessCount = this.samplesCount - this.samplesMax;

      for (let i = 0; i < this.samples.length && excessCount > 0; i++) {
        const sample = this.samples[i];

        if (sample.quantity <= excessCount) {
          datas.updates[sample.key] = 0;
          excessCount -= sample.quantity;
        } else {
          datas.updates[sample.key] = sample.quantity - excessCount;
          excessCount = 0;
        }
      }

      if (Object.keys(datas.updates).length > 0) {
        this.samples.forEach((sample) => {
          this.removeItem(sample);
        });

        console.log("Excess samples removed from cart");
      }
    }
  },
  getItemsBundle() {
    for (let item of bundleProducts) {
      this.itemsBundle.push(item);
      item.active = false;
    }
  },
  getMiniFragrances() {
    for (let frag of miniFragrancesProducts) {
      frag.enabled = false;
      for (let variant of frag.variants) {
        if (variant.title == "10ML") {
          frag.giftAvailability = variant.available;
        }
      }
      this.itemsMiniFragrances.push(frag);
    }
  },
  getProductPrice(item) {
    return item.original_price;
  },
  getSamples() {
    for (let sample of samplesProducts) {
      sample.enabled = false;
      sample.key_cart = false;
      this.itemsSamples.push(sample);
    }
  },
  getCount() {
    return this.itemsCount;
  },
  getTotal() {
    return renderAmount(this.total);
  },
  giftOption(state, item) {
    gsap.delayedCall(0.1, () => {
      let data = {
        id: item.key,
        properties: {},
      };
      for (let prop in item.properties) {
        data.properties[prop] = item.properties[prop];
      }
      data.properties._gift = this.gift_option;
      this.updateItem(data);
    });
  },
  //? direct = ouverture panier | modal = fragrances gifts
  patternSelection(selection) {
    this.patternBuy = selection;
    // console.log(this.patternBuy);
    if (selection == "fragrances-gifts") {
      this.openMiniFragrancesGifts();
    }
  },
  renderPrice(price, item) {
    if (price == 0) {
      let text = translations.free_product_price;
      if (
        typeof item != "undefined" &&
        typeof item.total_discount != "undefined" &&
        item.total_discount != 0
      ) {
        text += "<strike>" + renderAmount(item.total_discount) + "</strike>";
      }
      return text;
    } else {
      let text = "";
      text = renderAmount(price);
      if (item.discounts.length && item.discounts[0].amount != 0) {
        text += "<strike>" + renderAmount(item.original_price) + "</strike>";
      }

      return text;
    }
  },
  removeItem(item, state = true) {
    const data = {
      id: item.key,
      quantity: 0,
    };
    this.updateItem(data);
    this.getCart(state);
  },
  resetCart() {
    fetch("/cart/clear.js", {
      method: "post",
    })
      .then((response) => response.json())
      .then((data) => {
        this.getCart();
      });
  },
  showProperties(item) {
    const propertiesClean = item.properties;
    let showProps = [];
    for (let k in propertiesClean) {
      if (k != "_free_sample" && k != "_gift" && k != "_disable_gift_wrap") {
        // Product — SKU
        const captureText = propertiesClean[k].split(" — ");
        showProps.push(captureText[0].trim());
      }
    }
    return showProps.join(", ");
  },
  showGiftAlert() {
    Env.$html.classList.add("gift-alert-opened");
  },
  refreshCartDisplay(req) {
    this.items = req.items;
    this.itemsCount = req.item_count;
    this.total = req.total_price;
  },
  removeSamples() {
    // console.log("remove sample");
    let datas = {
      updates: {},
    };
    for (let item of this.items) {
      if (
        typeof item.properties._free_sample != "undefined" &&
        item.properties._free_sample == "true"
      ) {
        datas.updates[item.key] = 0;
      }
    }
    this.updateLinesItems(datas);
    Env.$html.classList.remove("sample-updated");
  },
  toggleSamplesBox(data) {
    let toggle = false;
    for (let item of data.items) {
      if (item.product_type != "" && item.product_type != "Product Bundle") {
        toggle = true;
      }
    }
    this.samplesEnabled = toggle;
    if (!this.samplesEnabled) {
      gsap.delayedCall(0.5, () => {
        this.removeSamples();
      });
    }
  },
  updateLinesItems(datas) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(datas),
    })
      .then((response) => response.json())
      .then((req) => {
        // console.log("end update lines items");
        this.refreshCartDisplay(req);
      })
      .catch((error) => {
        console.error("Error upading items from cart:", error);
      });
  },
  updateItem(data) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        this.items = data.items;
      })
      .catch((error) => {
        console.error("Error upading item from cart:", error);
      });
  },
  sampleUpdateEvent() {
    clearTimeout(timeoutSample);
    Env.$html.classList.add("sample-updated");
  },
});
